import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputNumber, InputSwitch, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './productgroup-model';  //editable..
import ProductChecklist from '../product/product-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class ProductgroupDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                }
                <InputNumber name='seq' label='Sequence' value={this.state.datarow.seq} error={this.state.errors?.seq} readOnly/>
                <InputPicklist name='productgroup' label='Sub Product Group List ' value='' caption={this.state.datarow.productgroupCaption} readOnly={this.state.datarow.productgroup? false: true} disableAutoClose>
                    <ProductChecklist history={this.props.history} currentId={this.state.datarow.productgroup} readOnly disableBackButton/>
                </InputPicklist>
                <InputPicklist name='product' label='Product' value='' caption={this.state.datarow.productCaption} readOnly={this.state.datarow.product? false: true} disableAutoClose>
                    <ProductChecklist history={this.props.history} currentId={this.state.datarow.product} readOnly disableBackButton/>
                </InputPicklist>
            </BaseDelete>
        );
    }
}